class LivePrice {
    customer = {
        customer: null,
        customer_hashed: null,
        shopify_customer: null,
        shopify_customer_hashed: null,
    };

    elements = [];
    failed = 0;
    activeFetches = Promise.resolve();
    watcher = null; // Holds the reference to setInterval

    /**
     * Number Formatter
     */
    formatter = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2, // ensure two decimal places
    });

    constructor(initialize = true) {
        this.fetchCustomer();
        this.fetchElements();

        if (initialize) {
            this.updatePrices();
            this.startWatcher();
        }

        window.livePrice = this;
    }

    fetchCustomer() {
        const customer = document.getElementById('customer');
        const customer_hashed = document.getElementById('customer_hashed');
        const shopify_customer = document.getElementById('shopify_customer');
        const shopify_customer_hashed = document.getElementById('shopify_customer_hashed');

        if (customer && customer_hashed) {
            this.customer.customer = customer.value;
            this.customer.customer_hashed = customer_hashed.value;
            this.customer.shopify_customer = shopify_customer.value;
            this.customer.shopify_customer_hashed = shopify_customer_hashed.value;
        }
    }

    fetchElements() {
        this.elements = document.querySelectorAll('[data-live-price]');
    }

    async fetchPrice(a, ah, callback) {
        this.activeFetches = this.activeFetches.then(() =>
            fetch('https://connect.shera-live.c-1714.maxcluster.net/live-price', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ c: this.customer.customer, ch: this.customer.customer_hashed, a: a, ah: ah })
            })
                .then(response => response.json())
                .then(json => {
                    const price = json[Object.keys(json)[0]];
                    callback(price);
                })
                .catch(error => {
                    console.error('Fetch Price Error:', error);
                    this.failed++;
                })
        );
    }

    async fetchCartPrice(items, callback) {
        this.activeFetches = this.activeFetches.then(() =>
            fetch('https://connect.shera-live.c-1714.maxcluster.net/live-cart-price', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    customer: { c: this.customer.shopify_customer, ch: this.customer.shopify_customer_hashed },
                    items: items
                }),
            })
                .then(response => response.json())
                .then(json => {
                    callback(json);
                })
                .catch(error => {
                    console.error('Fetch Cart Price Error:', error);
                    this.failed++;
                })
        );
    }

    updatePrice(element, price, variant, quantity) {
        // TODO: update currency based on customer
        element.innerText = this.formatter.format(price) + ' EUR';

        // set raw price attribute
        element.setAttribute('data-price_raw', price);

        // find elements with data-live-price-multiplied attribute and sku as value
        const elements = document.querySelectorAll(`[data-live-price-multiplied="${variant}"]`);

        for (let element of elements) {
            element.innerText = this.formatter.format(price * quantity) + ' EUR';
        }

        // prohibit further updates
        element.setAttribute('data-has-live-price', 'true');
    }

    async updatePrices() {
        if (this.failed > 5) {
            console.error("Too many failures, stopping price updates.");
            return; // early exit if too many failures
        }

        for (let element of this.elements) {
            const variant = element.getAttribute('data-variant');
            const variant_hashed = element.getAttribute('data-variant-hashed');
            const hasLivePrice = element.getAttribute('data-has-live-price');

            if (hasLivePrice !== 'true') {
                await this.fetchPrice(variant, variant_hashed, price => {
                    // check for a quantity and multiply the price
                    let quantity = element.getAttribute('data-quantity');

                    // if no quantity is set, default to 1
                    if (!quantity) {
                        quantity = 1;
                    }

                    this.updatePrice(element, price, variant, quantity);
                });
            }
        }
    }

    startWatcher() {
        this.watcher = setInterval(() => {
            if (this.failed > 5) {
                console.error('Failed to fetch prices too many times. Stopping watcher.');
                clearInterval(this.watcher);
                return;
            }

            this.fetchElements();
            this.updatePrices();
        }, 2000);
    }
}

if (typeof window.livePrice === 'undefined') {
    window.livePrice = new LivePrice();
    console.log('Live Price initialized');
} else {
    console.error('Live Price already initialized');
}
